import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { GlobalService } from 'app/shared/global.service';
import { User } from 'app/users/shared/user.model';
import { UserService } from 'app/users/shared/user.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
})

export class NavbarComponent {

    public currentUser: User;
    public translate: TranslateService;
    public languages: any = {
        en: 'English',
        de: 'Deutsch',
        it: 'Italiano',
        fr: 'Français',
    }

    constructor(private globalService: GlobalService,
        private userService: UserService,
        private router: Router,
        public translateService: TranslateService) {
            this.translate = translateService;
            this.currentUser = this.globalService.currentUser;
            this.globalService.$currentUser.subscribe((currentUser) => {
                this.currentUser = currentUser;
            });
    }

    changeLanguage(lang) {
        this.translate.use(lang)
    }

    browseAs(id) {
        this.userService.browseReset(id, false).subscribe(result => {
            swal(
                'Zurück zum Admin',
                'Admin Benutzer ist wiederhergestellt',
                'success'
            )
            if (result && result.id) {
                this.globalService.updateCurrentUser(result);
            } else {
                this.globalService.updateCurrentUser(this.currentUser);
            }
            this.router.navigateByUrl('/');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts